import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private themeSubject = new BehaviorSubject<Record<string, string>>({});
  theme$ = this.themeSubject.asObservable(); 

  constructor(
    private rendererFactory: RendererFactory2,
    private authService: AuthService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.initializeTheme(); 
  }

  private initializeTheme() {
    this.authService.user$.subscribe((user) => {
      if (user?.lgaSettings) {
        this.setTheme(user.lgaSettings);
      }
    });
  }

  setTheme(settings: Record<string, string>) {
    this.themeSubject.next(settings);
    
    setTimeout(() => {
      Object.entries(settings).forEach(([key, value]) => {
        const kebabKey = `--${this.camelToKebab(key)}`;
        document.documentElement.style.setProperty(kebabKey, value);
      });
    }, 0);
  }

  private camelToKebab(str: string): string {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }
}
